<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <v-card-title class="headline primary white--text">
        Consultar en Padron AFIP
      </v-card-title>

      <v-card-text class="pa-4" v-if="!cliente">
        <v-text-field
          label="Ingrese el DNI/CUIT"
          outlined
          v-model="documento"
        ></v-text-field>
        <v-btn
          block
          color="primary"
          large
          :disabled="!verificarDocumento"
          :loading="loading"
          @click="consultar"
          >CONSULTAR</v-btn
        >
      </v-card-text>
      <v-card-text v-else>
        <v-alert v-if="cliente.cliente" type="success" class="mt-2"
          >El cliente ya se encuentra registrado como
          <b>{{ cliente.cliente.nombre }}</b></v-alert
        >
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Apellido y Nombre
                </th>
                <th class="text-left">
                  Documento
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {{ `${cliente.datos.apellido} ${cliente.datos.nombre}` }}
                </td>
                <td>
                  {{ `${cliente.datos.tipoClave} ${cliente.datos.idPersona} ` }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Domicilio
                </th>
                <th class="text-left">
                  Localidad
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ `${cliente.datos.domicilio[0].direccion}` }}</td>
                <td>
                  {{
                    `${cliente.datos.domicilio[0].localidad}, ${cliente.datos.domicilio[0].descripcionProvincia} CP ${cliente.datos.domicilio[0].codigoPostal}`
                  }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-row>
          <v-col cols="12" md="6"
            ><v-text-field
              label="Correo electronico"
              v-model="contacto.email"
            ></v-text-field
          ></v-col>
          <v-col cols="12" md="6"
            ><v-text-field
              label="Numero de Telefono"
              v-model="contacto.sms"
            ></v-text-field
          ></v-col>
        </v-row>
        <v-btn block color="primary" large @click="seleccionarCliente"
          >SELECCIONAR CLIENTE</v-btn
        >
        <v-btn block text @click="cliente = null">BUSCAR OTRO DOCUMENTO</v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
export default {
  name: "NuevoCliente",
  props: {
    value: Boolean,
  },
  data: () => ({
    documento: "",
    loading: false,
    cliente: null,
    contacto: { email: "", sms: "" },
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(v) {
        return this.$emit("input", v);
      },
    },
    verificarDocumento() {
      return this.documento.length == 8 || this.documento.length == 11;
    },
  },
  methods: {
    async seleccionarCliente() {
      if (this.cliente.cliente) {
        this.$emit("seleccionarCliente", this.cliente.cliente._id);
        this.actualizarContactoCliente()
        this.dialog = false;
        this.cliente = null;
      } else {
          let tipo = this.cliente.datos.tipoDocumento == 'CUIT' ? 80 : 96
          let tipo_responsable = 5
          if(this.cliente.datos.tipoDocumento == 'CUIT') {
              tipo_responsable = this.cliente.datos.tipoDocumento == 'FISICA' ? 6 : 1
          }
          let datos = {
              nombre: `${this.cliente.datos.apellido} ${this.cliente.datos.nombre}`,
              documento: {
                  tipo,
                  numero: this.cliente.datos.idPersona
              },
              contactos: [
                  {
                      medio: 'sms',
                      dato: this.contacto.sms
                  },
                  {
                      medio: 'email',
                      dato: this.contacto.email
                  }
              ],
              direcciones: [{
                  descripcion: 'Fiscal',
                  direccion_1: this.cliente.datos.domicilio[0].direccion,
                  direccion_2: this.cliente.datos.domicilio[0].datoAdicional || '',
                  ciudad: this.cliente.idCiudad,
                  cp: this.cliente.datos.domicilio[0].codigoPostal,
                  provincia: this.cliente.idProvincia,
                  pais: '600d85b372a88c3dd40bbadf'
              }],
              tipo: 'CLIENTE',
              tipo_responsable
          }
        const res = await axios.post('/persona/nuevo', datos)
        this.$emit('nuevoCliente', res.data)
        this.dialog = false;
        this.cliente = null;
      }
    },
    async actualizarContactoCliente() {
        await axios.post('/personas/establecerContacto', { _id: this.cliente.cliente._id, datos: this.contacto })
    },
    async consultar() {
      this.loading = true;
      try {
        const res = await axios.post("/personas/consultaAFIP", {
          documento: this.documento,
        });
        this.cliente = res.data;
        this.contacto = { email: "", sms: "" }
        if(res.data.cliente && res.data.cliente.contactos.length) {
            let sms = res.data.cliente.contactos.find(v => v.medio == 'sms') 
            if(sms) this.contacto.sms = sms.dato
            let email = res.data.cliente.contactos.find(v => v.medio == 'email') 
            if(email) this.contacto.email = email.dato
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
  },
};
</script>
